<template>
  <div role="list" class="breadcrumbs">
    <template v-for="(breadcrumb, i) in breadcrumbs" :key="i">
      <nav-link
        v-if="breadcrumb.link"
        role="listitem"
        :to="breadcrumb.link"
        class="crumb"
      >
        <span v-if="typeof breadcrumb.label === 'string'">
          {{ $t(breadcrumb.label) }}
        </span>
        <component :is="breadcrumb.label" v-else />
      </nav-link>
      <span v-else-if="typeof breadcrumb.label === 'string'">
        {{ $t(breadcrumb.label) }}
      </span>

      <arrow v-if="i !== breadcrumbs.length - 1" class="arrow" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, unref } from 'vue';
import { useLink, useRoute } from 'vue-router';
import Arrow from '@images/arrow.svg?component';
import NavLink from '@components/structure/navigation/NavLink.vue';
import { useHeader } from './injects';
import { useStore } from '@/store';
import { canAccess } from '@/utils/user';

const header = useHeader();

const route = useRoute();
const store = useStore();
const dashboardLink = useLink({ to: { name: 'dashboard', params: { locale: 'de' } } });
const breadcrumbs = computed(() => [
  {
    label: 'navigation.dashboard.DEFAULT',
    link: canAccess(store.state.auth.user, dashboardLink.route.value?.meta?.roles as string[])
      ? { name: 'home' }
      : undefined,
  },
  ...((route.meta.breadcrumbs ?? []) as Array<{ label: string; link: string }>),
  ...(header?.extraBreadcrumbs ? (unref(header.extraBreadcrumbs)?.map((item) => unref(item)) ?? []) : []),
]);
</script>

<style lang="scss" scoped>
.arrow {
  @apply text-tab-item;

  width: px(15);

  :deep(path) {
    fill: currentColor;
    stroke: currentColor;
  }
}

.breadcrumbs {
  @apply flex gap-x-3;
  @apply text-tab-item;
  @apply transition-colors;

  font-size: px(16);
  font-weight: $regular;
  line-height: px(22);
  text-transform: uppercase;

  .crumb {
    @apply flex items-center;
    &:hover,
    &:last-child {
      @apply text-black;
    }
  }
}
</style>
